import { UserState } from '.';
import type { RootState } from '..';

export const getUserState = (state: RootState): UserState => state.user;

export const getRestaurantId = (state: RootState): number | undefined =>
    getUserState(state).user?.restaurants[0].restaurantId;

export const getRestaurantName = (state: RootState): string | undefined =>
    getUserState(state).user?.restaurants[0].name;
